import CMN from './CMN'
import ENG from './ENG'

export default {
  CMN,
  ENG,
}
